import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import ReactDOM from "react-dom";
import { usePopperTooltip } from "react-popper-tooltip";
import { Config } from "react-popper-tooltip/dist/types";

interface IProps {
  content: string | JSX.Element;
  config?: Config;
  contentWrapperStyles?: CSSProperties;
}

const Root = styled.div`
  display: flex;
  width: max-content;
  box-sizing: border-box;
  padding: 12px;

  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.04), 0px 4px 10px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  /* Portaled to <body>, so keep this above map controls / dropdown menus. */
  z-index: 9999;
`;
const Tooltip: React.FC<IProps> = ({
  contentWrapperStyles,
  children,
  content,
  config,
}) => {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({ ...config });
  const props = getTooltipProps();
  return (
    <div>
      <div ref={setTriggerRef} style={{ cursor: "pointer" }}>
        {children}
      </div>
      {visible &&
        // Render into <body> via a portal so the tooltip isn't clipped by any
        // ancestor with `overflow: hidden/auto` (e.g. the scrollable dropdown menu).
        ReactDOM.createPortal(
          <Root
            ref={setTooltipRef}
            {...props}
            style={{ ...props.style, ...contentWrapperStyles }}
          >
            {content}
          </Root>,
          document.body
        )}
    </div>
  );
};
export default Tooltip;
